import React, {Component} from 'react';
import {toast} from 'react-toastify';
import {Form} from 'react-final-form';
import PropTypes from 'prop-types';
import {Panel, TextField, SaveButton, Button} from '../../common';
import {MAX_PASSWORD_LEN, MIN_PASSWORD_LEN} from '../../../configs/constants';
import {goHistoryBack} from '../../../utils';
import {
  nolessErrorMessage,
  nolongerErrorMessage, noSpacesErrorMessage,
  passwordDoesNotMatch, retypedPasswordDoesNotMatch, passwordChanged,
} from '../../../configs/messages';

export default class EditPassword extends Component {
  static propTypes = {
    onChangePassword: PropTypes.func.isRequired,
    updatePasswordSuccess: PropTypes.bool.isRequired,
  };

  componentWillReceiveProps(nextProps) {
    const {updatePasswordSuccess} = nextProps;
    if (updatePasswordSuccess) {
      toast.success(passwordChanged);
      goHistoryBack();
    }
  }

  onFormSubmit = (data) => {
    const {onChangePassword} = this.props;
    const {oldPassword, newPassword} = data;
    return onChangePassword({oldPassword, newPassword});
  };

  onBackButtonClick = () => {
    goHistoryBack();
  }

  validatePassword = (password = '', allValues = {}) => {
    const passwordTrimmed = password.trim();
    const savedPassword = allValues.confirmPassword;

    if (/\s/g.test(password)) {
      return noSpacesErrorMessage('Password');
    }
    if (passwordTrimmed.length < MIN_PASSWORD_LEN) {
      return nolessErrorMessage('Password', MIN_PASSWORD_LEN);
    }
    if (passwordTrimmed.length > MAX_PASSWORD_LEN) {
      return nolongerErrorMessage('Password', MAX_PASSWORD_LEN);
    }
    if (savedPassword && passwordTrimmed !== savedPassword) {
      return passwordDoesNotMatch;
    }

    return null;
  };

  validateConfirmPassword = (password = '', allValues = {}) => {
    const passwordTrimmed = password && password.trim();
    const savedPassword = allValues.password;

    if (/\s/g.test(password)) {
      return noSpacesErrorMessage('Password');
    }
    if (passwordTrimmed.length < MIN_PASSWORD_LEN) {
      return nolessErrorMessage('Password', MIN_PASSWORD_LEN);
    }
    if (passwordTrimmed.length > MAX_PASSWORD_LEN) {
      return nolongerErrorMessage('Password', MAX_PASSWORD_LEN);
    }
    if (savedPassword && passwordTrimmed !== savedPassword) {
      return retypedPasswordDoesNotMatch;
    }

    return null;
  };

  render() {
    return (
      <Panel
        title="Edit Password"
        size="m"
        headerSize="m"
        cls="profile-password"
      >
        <Form
          onSubmit={this.onFormSubmit}
          validateOnBlur={false}
          render={({handleSubmit, pristine, invalid}) => (
            <form
              action="#"
              className="form"
              onSubmit={handleSubmit}
            >
              <TextField
                label="Old Password"
                name="oldPassword"
                inputType="password"
                required
              />
              <TextField
                label="New Password"
                name="newPassword"
                inputType="password"
                validatorsArray={[this.validatePassword]}
                required
              />
              <TextField
                label="Retype Password"
                name="confirmPassword"
                inputType="password"
                validatorsArray={[this.validateConfirmPassword]}
                required
              />

              <div className="row row_center">
                <Button size="xl" text="Back" handler={this.onBackButtonClick}/>
                <SaveButton size="xl" type="submit" text="Submit" disabled={pristine || invalid}/>
              </div>
            </form>
          )}
        />
      </Panel>
    );
  }
}
